import React from 'react';
import { RaceSetupDialog } from './RaceSetupDialog';

interface RaceSetupMenuProps {
  open: boolean;
  onClose: () => void;
  onStart: (carId: string, trackId: string) => void;
  onOpenGarage: () => void;
}

export const RaceSetupMenu: React.FC<RaceSetupMenuProps> = ({
  open,
  onClose,
  onStart,
  onOpenGarage,
}) => {
  return (
    <RaceSetupDialog
      open={open}
      onCancel={onClose}
      onStart={onStart}
      onOpenGarage={onOpenGarage}
    />
  );
};

export default RaceSetupMenu;
